import types from '../constants/actionTypes';
import { List, OrderedSet, Map, fromJS } from 'immutable';

const collectives = (state, action) => {
  switch (action.type) {
    case types.dataFetching.SAVE_NEW_COLLECTIVE_REQUEST:
      state = state.set('isFetching', true);
      break;
    case types.dataFetching.SAVE_NEW_COLLECTIVE_REQUEST_SUCCESS:
      state = state.merge(action.payload.collective)
                    .set('isFetching', false);
      break;
    case types.dataFetching.SAVE_NEW_COLLECTIVE_REQUEST_ERROR:
      state = state.set('isFetching', false);
      break;
    case types.collectives.NEXT_PAGE_REQUEST:
    case types.collectives.FILTER_RESULTS_REQUEST:
      state = state.set('isFetching', true);
      break;
    case types.collectives.NEXT_PAGE_SUCCESS:
      state = state.set('isFetching', false)
                    .mergeIn(['result'], OrderedSet(action.payload.collectives.result))
                    .set('nextPage', action.payload.collectives.nextPage)
                    .mergeIn(['items'], action.payload.collectives.items)
                    .set('collectiveReportButton', false);
      break;
    case types.collectives.FILTER_RESULTS_SUCCESS:
      state = state.set('isFetching', false)
                    .set('result', OrderedSet(action.payload.collectives.result))
                    .set('nextPage', action.payload.collectives.nextPage)
                    .mergeIn(['items'], action.payload.collectives.items)
                    .set('collectiveReportButton', false);
      break;
    case types.dataFetching.SEARCH_COLLECTIVES_REQUEST_ERROR:
      state = state.set('isFetching', false);
      break;
    case types.dataFetching.GENERATE_COLLECTIVE_REPORT_REQUEST:
      state = state.set('isFetching', true);
      break;
    case types.dataFetching.GENERATE_COLLECTIVE_REPORT_REQUEST_ERROR:
      state = state.set('isFetching', false);
      break;
    case types.dataFetching.GENERATE_COLLECTIVE_REPORT_REQUEST_SUCCESS:
      state = state.set('isFetching', false)
                    .set('collectiveReportButton', true);
      break;
    case types.dataFetching.REMOVE_COLLECTIVE_REQUEST:
      state = state.set('isFetching', true);
      break;
    case types.dataFetching.REMOVE_COLLECTIVE_ERROR:
      state = state.set('isFetching', false);
      break;
    case types.dataFetching.REMOVE_COLLECTIVE_SUCCESS:
      state = state.deleteIn(['items', `${action.payload.collective.result}`])
                    .update('result', (result) => result.filter((id) => id !== action.payload.collective.result))
                    .set('isFetching', false);
      break;
    case types.dataFetching.UPDATE_COLLECTIVE_REQUEST:
    case types.collectives.SINGLE_REQUEST:
      state = state.set('isFetching', true);
      break;
    case types.dataFetching.UPDATE_COLLECTIVE_SUCCESS:
    case types.collectives.SINGLE_SUCCESS:
      state = state.mergeIn(['items'], action.payload.collective.items)
          .set('isFetching', false);
      break;
    case types.collectives.NEW_COLLECTIVES_SUCCESS:
      if (action.payload.collectives.result.length) {
        state = state.set('items', fromJS(action.payload.collectives.items))
          .set('isFetching', false);
        state = state.set('result', List(action.payload.collectives.result));
      }

      break;
    case types.collectives.MERGE_DIALOG_REQUEST:
      state = state.set('mergeId', action.id);
      break;
    case types.collectives.MERGE_DIALOG_CANCEL:
      state = state.set('mergeId', 0);
      break;
    case types.collectives.SET_MERGE_INTO:
      state = state.set('mergeIntoId', action.id);
      break;
    case types.collectives.CLEAR_ALL:
      state = state.set('items', Map());
      state = state.set('result', OrderedSet());
      state = state.delete('nextPage');
    case types.dataFetching.FETCH_INITIAL_DATA_SUCCESS:
      state = state.set('totalSystemCount', action.payload.collectiveCount);
      break;
    case types.collectives.RESET_REPORT_BUTTON:
      state = state.set('collectiveReportButton', false);
      break;
    case types.collectives.SET_ACTIVE:
      state = state.setIn(['items', action.id.toString(), 'active'], action.value);
      break;
  }
  return state;
};

export default collectives;



/** WEBPACK FOOTER **
 ** ./reducers/collectives.js
 **/